export default __webpack_public_path__ + "static/media/alert.b18b1eb1.png";